import { FC, useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "../../parametrage/Pays/Pays";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { cellStyle } from "../../parametrage/Pays/RowPays";
import { IConsolidationCommission } from "./IConsolidationCommission";
import SeconNiveauConsolidation from "./SeconNiveauConsolidation";

interface RowConsolidationCommissionProps {
  userWithConsolidation: IConsolidationCommission;
  consolidationPar: number;
  typeConsolidation: number;
}

const RowConsolidationCommission: FC<RowConsolidationCommissionProps> = ({
  userWithConsolidation,
  consolidationPar,
  typeConsolidation,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <TableRow>
        <TableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{ color: "#fff", fontSize: 12 }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithConsolidation?.prenom}
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithConsolidation?.name}
        </TableCell>
        <TableCell style={cellStyle} align="center">
          {userWithConsolidation?.email}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={cellStyle} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {consolidationPar !== 0 && (
                      <StyledTableCell style={cellStyle} align="center">
                        Client
                      </StyledTableCell>
                    )}

                    {consolidationPar === 2 && (
                      <StyledTableCell style={cellStyle} align="center">
                        Operation
                      </StyledTableCell>
                    )}
                    {typeConsolidation === 2 && (
                      <StyledTableCell style={cellStyle} align="center">
                        Mois
                      </StyledTableCell>
                    )}

                    <StyledTableCell style={cellStyle} align="center">
                      Année
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      CA
                    </StyledTableCell>
                    <StyledTableCell style={cellStyle} align="center">
                      Commission
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userWithConsolidation?.herConsolidationparType?.map(
                    (consolidationParType) => (
                      <SeconNiveauConsolidation
                        consolidationParType={consolidationParType}
                        consolidationPar={consolidationPar}
                        typeConsolidation={typeConsolidation}
                        codeIsoDeviseUser={userWithConsolidation?.devise_commission?.code_iso}
                      />
                    )
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RowConsolidationCommission;
